module.exports = __webpack_public_path__ + "static/img/banner_aboutus.9df33d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/banner_aboutus.png
// module id = KpWV
// module chunks = 15